import { Routes } from '../api-routes'
import { PromptKeywordDTO, PromptTemplateDTO } from '../dtos/organization'
import { getPath, setP } from './helpers'

export namespace PromptTemplatesRoutes {
  export namespace get {
    export function call(p = setP(['organizationId'])) {
      return getPath(p, { prefix: 'admin', suffix: Routes.PromptTemplates })
    }

    export type Response = {
      template: PromptTemplateDTO
      keywords: PromptKeywordDTO[]
    }[]
  }

  export namespace getRevisions {
    export function call(p = setP(['organizationId', 'promptTemplateType'])) {
      return getPath(p, { prefix: 'admin', suffix: Routes.Revisions })
    }

    export type Response = { promptTemplates: PromptTemplateDTO[] }
  }

  export namespace getOne {
    export function call(p = setP(['organizationId', 'promptTemplateType'])) {
      return getPath(p, { prefix: 'admin' })
    }

    export type Response = { promptTemplate: PromptTemplateDTO }
  }

  export namespace getKeywords {
    export function call(p = setP(['organizationId', 'promptTemplateType'])) {
      return getPath(p, { prefix: 'admin', suffix: Routes.Keywords })
    }

    export type Response = { keywords: PromptKeywordDTO[] }
  }

  export namespace patchOne {
    export function call(
      p = setP(['organizationId', 'promptTemplateType', 'promptTemplateId']),
    ) {
      return getPath(p, { prefix: 'admin' })
    }

    export type Request = { fields: Pick<PromptTemplateDTO, 'promptText'> }
    export type Response = {
      promptTemplate: PromptTemplateDTO
    }
  }
}
